export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-8403WQHD_white-7c63f5b532350853d60c8213efb16a0c.webp";